/**
 * Cardhamster: "Haeufig zusammen gekauft"
 * Laedt Shopify-Produktempfehlungen, zeigt sie mit Checkboxen an,
 * berechnet den Gesamtpreis der ausgewaehlten Artikel und legt sie
 * beim Klick gesammelt in den Warenkorb.
 */
(function () {
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
    });
  }

  function recalcTotal(root) {
    var total = 0;
    root.querySelectorAll('.ch-fbt__item').forEach(function (item) {
      var checkbox = item.querySelector('.ch-fbt__checkbox');
      if (checkbox && checkbox.checked) {
        total += parseInt(item.getAttribute('data-price'), 10) || 0;
      }
    });
    var totalEl = root.querySelector('.ch-fbt__total');
    if (totalEl) totalEl.textContent = formatMoney(total);
  }

  function buildItem(product) {
    var variant = product.variants.find(function (v) {
      return v.available;
    }) || product.variants[0];

    if (!variant) return null;

    var wrapper = document.createElement('div');
    wrapper.className = 'ch-fbt__plus';
    wrapper.textContent = '+';

    var item = document.createElement('div');
    item.className = 'ch-fbt__item';
    item.setAttribute('data-variant-id', variant.id);
    item.setAttribute('data-price', variant.price);

    var checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.checked = true;
    checkbox.className = 'ch-fbt__checkbox';
    checkbox.setAttribute('aria-label', product.title);

    var img = document.createElement('img');
    img.src = (product.images && product.images[0]) || product.featured_image || '';
    img.alt = product.title;
    img.className = 'ch-fbt__image';
    img.loading = 'lazy';
    img.width = 72;
    img.height = 72;

    var info = document.createElement('div');
    info.className = 'ch-fbt__info';

    var titleLink = document.createElement('a');
    titleLink.href = product.url;
    titleLink.className = 'ch-fbt__title ch-fbt__title--link';
    titleLink.textContent = product.title;

    var price = document.createElement('span');
    price.className = 'ch-fbt__price';
    price.textContent = formatMoney(variant.price);

    info.appendChild(titleLink);
    info.appendChild(price);

    item.appendChild(checkbox);
    item.appendChild(img);
    item.appendChild(info);

    var fragment = document.createDocumentFragment();
    fragment.appendChild(wrapper);
    fragment.appendChild(item);
    return fragment;
  }

  function initWidget(root) {
    var productId = root.getAttribute('data-product-id');
    var limit = root.getAttribute('data-limit') || 2;
    var sectionId = root.getAttribute('data-section-id');
    var itemsWrap = document.getElementById('ChFbtItems-' + sectionId);
    var loadingEl = document.getElementById('ChFbtLoading-' + sectionId);
    var addButton = document.getElementById('ChFbtAdd-' + sectionId);

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related')
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (loadingEl) loadingEl.remove();

        if (!data.products || data.products.length === 0) {
          root.style.display = 'none';
          return;
        }

        data.products.forEach(function (product) {
          var fragment = buildItem(product);
          if (fragment) itemsWrap.appendChild(fragment);
        });

        itemsWrap.querySelectorAll('.ch-fbt__checkbox').forEach(function (checkbox) {
          checkbox.addEventListener('change', function () {
            recalcTotal(root);
          });
        });

        recalcTotal(root);
      })
      .catch(function () {
        if (loadingEl) loadingEl.remove();
        root.style.display = 'none';
      });

    if (addButton) {
      addButton.addEventListener('click', function () {
        var items = [];
        root.querySelectorAll('.ch-fbt__item').forEach(function (item) {
          var checkbox = item.querySelector('.ch-fbt__checkbox');
          if (checkbox && checkbox.checked) {
            items.push({
              id: parseInt(item.getAttribute('data-variant-id'), 10),
              quantity: 1,
            });
          }
        });

        if (items.length === 0) return;

        addButton.disabled = true;
        addButton.classList.add('loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root + 'cart'
              : '/cart';
          })
          .catch(function () {
            addButton.disabled = false;
            addButton.classList.remove('loading');
            alert('Die Artikel konnten nicht zum Warenkorb hinzugefuegt werden. Bitte versuch es erneut.');
          });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ch-fbt').forEach(initWidget);
  });
})();
